<template>
</template>

<script>
export default {
    data() {
        return {}
    }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/pages/Preload.vue